import { useEffect, useState } from 'react';

import { useSession } from '@eneco/auth';
import logger from '@eneco/common/log';
import { getAccountSwitchHref } from '@eneco/components-next/AccountCard/accountSwitchHelpers';
import useDC from '@eneco/dc/useDC';
import { useRouter } from '@eneco/next';

import { useFlowHooks } from '../../utils/FlowProvider';

export const useCachedAccount = () => {
  const [isReady, setIsReady] = useState(false);
  const { reload } = useRouter();
  const { data: session } = useSession();
  const { accountId } = useDC();

  const { useFlowSelector } = useFlowHooks();
  const flowContext = useFlowSelector(state => state);

  const {
    context: { accountId: cachedAccountId },
  } = flowContext;

  useEffect(() => {
    async function switchToCachedAccount(cachedAccountId: number) {
      try {
        const formData = new FormData();
        formData.append('accountId', cachedAccountId.toString());

        await fetch(getAccountSwitchHref(cachedAccountId.toString()), {
          method: 'POST',
          headers: { authorization: `Bearer ${session?.idToken}` },
          body: formData,
        });
        reload();
      } catch (error) {
        logger.error('Wz6mag', `Unexpected error for switching accounts`, error);
      } finally {
        setIsReady(true);
      }
    }
    if (cachedAccountId && cachedAccountId !== accountId) {
      void switchToCachedAccount(cachedAccountId);
    } else {
      setIsReady(true);
    }
  }, []);

  return isReady;
};
